import React from "react";
import { MediaTabContainer, MediaTabCell } from "./_styled";
import { useMediaSrc } from "../../hooks/useMediaSrc";
import useVideo from "../../hooks/useVideo";
import { getVideoUrl, transformations } from "../../util/get-url-utils";
import { affordances } from "../../util/analytics";
import MediaItem from "../MediaItem";

const MediaGallery = ({
  mediaItems,
  type,
  handleOpenLightBox,
  isMobileDevice,
  isTabletDevice,
}) => {
  const { mediaUrlsSmall, mediaUrlsMedium, mediaUrlsLarge } = useMediaSrc(
    mediaItems,
    type
  );
  const { cloudinaryUrl } = useVideo();

  if (!mediaItems) {
    return <></>;
  }

  return (
    <MediaTabContainer container wrap data-testid="media-tab-root">
      {mediaItems &&
        mediaItems.map((item, index) => {
          let imageSrcSet = null;
          let imageSrc = null;
          let imageSize = null;
          let videoUrl = null;

          if (type === "images") {
            imageSrcSet = `
                    ${mediaUrlsSmall[index]} 257w, 
                    ${mediaUrlsMedium[index]} 300w,
                    ${mediaUrlsLarge[index]} 500w
                    `;
            imageSrc = mediaUrlsSmall[index];
            imageSize = `(min-width: 1040px) calc(20vw - 22px),
            (min-width: 640px) calc(33vw - 27px),
            calc(100vw - 20px)`;
          } else {
            videoUrl = `${getVideoUrl(
              item.publicId,
              cloudinaryUrl,
              transformations.small
            )}.jpg`;
          }
          return (
            <MediaTabCell
              data-testid="media-item"
              cell
              justify={{ content: "center" }}
              key={`${type}-${index}-${item.id}`}
            >
              {
                <MediaItem
                  index={index}
                  {...item}
                  type={type}
                  imageSrc={imageSrc}
                  imageSize={imageSize}
                  imageSrcSet={imageSrcSet}
                  videoUrl={videoUrl}
                  openLightBox={() => {
                    handleOpenLightBox(index, affordances.TOPIC_GALLERY);
                  }}
                  isMobileDevice={isMobileDevice}
                  isTabletDevice={isTabletDevice}
                />
              }
            </MediaTabCell>
          );
        })}
    </MediaTabContainer>
  );
};
export default MediaGallery;
